import React, { useContext } from "react";
import Row from "react-bootstrap/Row";
import { AppState } from "../lib/context/AppProvider";
import { useNavigate } from "react-router-dom";
import { INDIVIDUAL_HEADER_HEIGHT } from "../utils/headers";

const OptHeader = () => {
    const {exercise, includeExerciseData} = useContext(AppState);
    const navigate = useNavigate();

    const style = {
        height: `${INDIVIDUAL_HEADER_HEIGHT}px`,
        minHeight: `${INDIVIDUAL_HEADER_HEIGHT}px`,
        backgroundColor: "#1ab000",
        color: "#ffffff",
        fontSize: "12px",
        textAlign: "center",
        verticalAlign: "top",
        lineHeight: `${INDIVIDUAL_HEADER_HEIGHT}px`
    };
    
    return <>
        {exercise?.name && (
            <div className="bg-dark">
                <Row className="topbar g-0 p-0" data-testid="opt-header" style={{
                    ...style,
                    backgroundColor: "#004990",
                }}><p>
                    {exercise.name.toUpperCase()} EXERCISE
                </p>
                </Row>
            </div>
        )}
        {includeExerciseData && (
            <div className="bg-dark">
                <Row className="topbar g-0 p-0" data-testid="opt-header-ex-data" style={{
                    ...style,
                    backgroundColor: "rgb(0, 81, 255)",
                    cursor: "pointer"
                }} onClick={() => {
                    navigate("/settings#general");
                }}><p>
                    EXERCISE DATA ENABLED
                </p>
                </Row>
            </div>
        )}
    </>;
};

export default OptHeader;
